import loadable from '@wix/yoshi-flow-editor/loadable';

export const CentralFeed = loadable(
  () => import(/* webpackChunkName: "CentralFeed" */ './CentralFeed'),
  {
    resolveComponent: (component) => component.CentralFeed,
  },
);
